export default "__VITE_ASSET__e44e2992__"